module.exports = {"translations":{"step-price-loader-advantage-program-cu":"Overfører medlemsinfo $[organizationName] til prisberegner","step-confirmation-full-purchase-list2":""}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/dog/cu/package.dog-tjm-text.json
// module id = 720
// module chunks = 0